import type { MarkHunt } from '../../api';

/** Samma gräns som API:t (HUNT_MAX_AGE_MS): en jakt utan avslut räknas som pågående i 12 timmar. */
export const HUNT_MAX_AGE_MS = 12 * 60 * 60_000;

export type ChatHuntStatus =
  | { state: 'unknown' }                       // statusen är inte hämtad än
  | { state: 'active' }                        // pågår: visa Anslut
  | { state: 'ended'; endedAt: number | null } // avslutad (endedAt saknas för gamla jakter)

/**
 * Status för en "Jakt startad"-rad i gruppchatten.
 * @param activeMeetingId jakten som servern just nu räknar som pågående (activeMarkHunt)
 * @param hunts raderna ur mark_hunts för chattens jakter, eller null innan de hämtats
 */
export function chatHuntStatus(meetingId: string, activeMeetingId: string | null, hunts: MarkHunt[] | null, now = Date.now()): ChatHuntStatus {
  if (activeMeetingId === meetingId) return { state: 'active' };
  if (!hunts) return { state: 'unknown' };
  const row = hunts.find(h => h.meetingId === meetingId);
  if (row && row.endedAt == null && now - row.startedAt < HUNT_MAX_AGE_MS && activeMeetingId == null) return { state: 'active' };
  return { state: 'ended', endedAt: row?.endedAt ?? null };
}
